import * as ThreePackage from "three";
export const THREE: any = ThreePackage;
export { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
